export const helpEn = {
  open: 'Open help',
  title: 'Help',
  search: 'Search help',
  noResults: 'No matching help articles.',
  loading: 'Loading help…',
  error: 'Help could not be loaded.',
  retry: 'Try again',
  fallback: 'This article is not yet available in your language.',
  allTopics: 'All topics',
  related: 'Related topics',
  empty: 'No help articles are currently available for your role. You can reload the content.',
  translationStatus:
    '{{current}}/{{total}} articles current · {{locales}} languages · {{fallback}} fallbacks · {{stale}} stale',
  categories: {
    general: 'General',
    accounting: 'Accounting',
    documents: 'Documents',
    finance: 'Finance',
    'getting-started': 'Getting started',
    manufacturing: 'Manufacturing',
    marketing: 'Marketing',
    partners: 'Business partners',
    plm: 'Product development',
    portal: 'Customer portal',
    products: 'Products',
    questionnaires: 'Questionnaires',
    sales: 'Sales',
    security: 'Security',
    settings: 'Settings',
  },
} as const;
